// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1WBAs","additionalInfo":"AgreementModal_additionalInfo__3XCSj"};